
import React, {useEffect, useRef} from 'react'
import { Row } from "antd";
import { SafetyCertificateOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

const PurposeCommit2 = () => {
    const serviceRef = useRef(null)
    useEffect(() => {
        
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('fadeInLeft2')
              }
            })
          },
          {
            threshold: 0.5
          }
        )

        const serviceRefCurrent = serviceRef.current
    
        if (serviceRefCurrent) {
          observer.observe(serviceRefCurrent)
        }
    
        return () => {
          if (serviceRefCurrent) {
            observer.unobserve(serviceRefCurrent)
          }
        }
      
    }, [])

    return (
        <>
            <StyledDiv
                style={{
                    marginTop: "20px"
                }}
                className='landingCommitmentText'
                ref={serviceRef}
            >
                <Row justify="start">
                    <SafetyCertificateOutlined className="landingCommitmentIcon" />
                    <label style={{
                      marginTop: "4px"
                    }}>Healthy and Safe Workplace</label>
                </Row>
                {/* <label>•	Healthy and Safe Workplace</label> */}
            </StyledDiv>
        </>
    )
}

export default PurposeCommit2
